import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const PaymentVariants = styled.div`
    flex-direction: column;
    margin-top: 16px;

    @media (min-width: ${wideBreakpoints.mobile}) {
        width: calc(100% + 4px);
        margin-left: -8px;
    }
`;

export const BtnWrap = styled.div`
    flex-direction: column;
    margin-top: 20px;
    width: 100%;

    & > * {
        margin-bottom: 12px;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const Button = styled(BaseButton)`
    width: 100%;
`;
